
import { Component, Vue, Prop } from "vue-property-decorator";
import Bus from "@/lib/Bus"
const bus: Bus = new Bus().getBus();
import  ButtonVue from "@/lib/Button.vue";
import UploaderVue from "@/uploader/Uploader.vue";
import { MasterData } from "@/store/MasterData";
import Store from "@/store/Store";
import { IUser } from "@/../../server/src/user/IUser";
import { Finder, IFinder } from "@/finder/IFinder";
import FinderInlineVue from "@/finder/FinderInline.vue";
import { Debouncer } from "@/lib/Debouncer"
import { Searcher } from "./Searcher"
import  ModalVue from "@/Modal.vue";

@Component({ components: { FinderInlineVue, ButtonVue,  ModalVue} })
export default class SearcherVue extends Vue {
    customers:any[]=[]
    users:IUser[]=[]
    key=0;
    
    komponenty:any[]=[]
    ksztalty:any[]= [{id:undefined,opis:'Wybierz kształt'},{id:'P',opis:'Prostokąt'},{id:'K',opis:'Okrąg'}, {id:'O',opis:'Owal'},{id:'S',opis:'Specjalny'},{id:'E',opis:'Elipsa'}, {id:'N',opis:'Nieregularny'}]
    show_deleted:any[]= [{id:0,opis:'Aktualne'},{id:1,opis:'Śmietnik'}, {id:3,opis:'Aktualne+Śmietnik'}]

    
    @Prop(Object) searcher!: Searcher;
    @Prop(Boolean) full!: Boolean;
   

    //ksztalt_text:string=""
    //ksztalt_key=0
    debounced:any;

    async mounted() {
        console.log("Searcher.vue mounted")
        await this.searcher.read()
        this.debounced = Debouncer.debounce(await (this.refresh.bind(this)), 2000).bind(this);
        console.log('mounted',this.$route.params.prj_id)
        const masterData: MasterData|undefined =  await (await new Store().getStore()).masterData;
        if (!masterData) return;
        this.users         = masterData.users
        this.customers     = masterData.customers

        this.komponenty = (<any>masterData.komponenty).surowiec

        if (!this.searcher.komponent_finder) this.searcher.komponent_finder=new Finder();
        this.update_finder(this.searcher.komponent_finder, this.komponenty)

        await this.refresh()
    }

    async update_finder(finder:Finder, kk:any[]) {
    
    if (!finder._id) return;
    (<any> finder).changed = undefined;

    for (let i=0;i<kk.length;i++) {
      let k=<any> kk[i]
      if (k._id == finder._id) {
     
        if (k.text != finder.text) {
          
          (<any> finder).changed = k;
          k.data=finder.data
          k.filter=finder.filter
          this.key++
        }
      }
    }
  }


    created() {
        bus.register("searcher.handlowiec_selected", this.changed);
        bus.register("searcher.klient_selected", this.changed);
        bus.register("searcher.komponent_selected", this.komponent_selected)
    }

    beforeDestroy() {
        bus.remove("searcher.handlowiec_selected", this.changed);
        bus.remove("searcher.klient_kontakt_selected", this.changed);
        bus.remove("searcher.komponent_selected", this.komponent_selected)
    }

    async refresh() {
        this.$emit("searcher_changed",this.searcher);
        //this.key++ WAŻNE !!!
    }

  

    async komponent_selected(e:any) {
      console.log("searcher: komponent_selected")
      this.searcher.komponent_finder = e.detail;
      this.searcher.komponent_id = undefined;
      if (this.searcher.komponent_finder._id) {
        this.searcher.komponent_id = this.searcher.komponent_finder._id
        //alert(JSON.stringify(this.searcher.komponent_finder))
      } 
      await this.changed(undefined)
    }


    async changed(e:any) {
        console.log("searcher.changed() key handler", e?.key)
        if (e) {
          if (e.key == "Escape") {
            console.log("Escape -> abort list")
            return;
          }
          if (e.key == "Enter") {
            console.log("Enter -> getList()")
            return;
          }
          if (e.key == "ArrowDown") {
            console.log("ArrowDown -> getList()")
            return;
          }
          if (e.key == "Tab") {
            console.log("Tab -> return")
            return;
          }
        }
        this.searcher.save(this.searcher);
        await this.debounce()
    }


    async debounce() {
        await this.debounced()
    }

    
/*
    kchanged() {

      let found=0
      for (let i=0;i<this.ksztalty.length && !found;i++) {
        const o=this.ksztalty[i]
        const opis=o.opis;
        if (opis.toLocaleUpperCase().indexOf(this.ksztalt_text.toLocaleUpperCase())>-1) {
          found=1
          this.searcher.ksztalt_wykrojnika=o.id
          this.changed()
        }
      }

      console.log("kchanged")
      this.ksztalt_key++
    }
  */
}
